import AddRoadIcon from '@mui/icons-material/AddRoad'
import { Box, Tooltip, Typography } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-premium'
import { DensityStyleTypes } from '../../../../types'

interface RenderNameCellProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
  /** Optional — some call sites (renderAccountingColumns) pass null
   *  intentionally to render the cell as non-navigable. The onClick
   *  is a no-op when this is missing/null. */
  navigate?: ((route: string) => void) | null
}
const RenderDealNameCell: React.FC<RenderNameCellProps> = ({ params, navigate, densityStyles }) => {
  const { rowNode, row, value } = params
  const { PK, SK, isClone, isParent } = row
  const ncoStatus = params?.row?.ncoStatus
  const isChild = !isParent
  const depth = rowNode?.depth ?? 0
  const indent = depth * 20
  // only parent rows get an expand button
  const _isGroup = isParent
  // cast away TS so we can see the internal children array
  const internalNode = rowNode as any
  // const hasChildren = (internalNode.children?.length ?? 0) > 0
  const _hasChildren = params?.row?.hasChildRows
  const isExpanded = Boolean(internalNode.childrenExpanded)
  const route = isParent ? `/deals/${PK}/${SK}/details` : `/deals/${row?.PK}/DEAL_${row?.deal_uuid}/agreement`
  //@ts-ignore
  if (rowNode?.isAutoGenerated) return
  return (
    <Box
      sx={{
        display: 'flex',
        height: '100%',
        alignItems: 'center',
        pl: isChild ? `${indent}px` : densityStyles.padding,
        pt: densityStyles.padding,
        pb: densityStyles.padding,
        pr: densityStyles.padding,
        gap: densityStyles.gap,
        width: '100%',
        backgroundColor: 'transparent',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
      }}
      onClick={() => {
        if (typeof navigate === 'function') navigate(route)
      }}
    >
      <>
        {/* {isGroup && (
          <IconButton
            size="small"
            disabled={!hasChildren} // gray out if no children
            onClick={e => {
              e.stopPropagation()
              toggleExpanded(params.id)
            }}
            sx={{ color: hasChildren ? 'inherit' : 'text.disabled' }}
          >
            {isExpanded ? (
              <ExpandMoreIcon />
            ) : (
              <ChevronRightIcon sx={{ color: hasChildren ? 'text.primary' : 'text.disabled' }} />
            )}
          </IconButton>
        )} */}

        {/* child-dot only on non-parent rows */}
        {/* {isChild && (
          <FiberManualRecordIcon
            sx={{
              fontSize: 8,
              color: 'text.disabled',
              ml: 1,
              mr: 1,
            }}
          />
        )} */}
        {isParent ? (
          <>
            <Tooltip
              title={<Typography sx={{ backgroundColor: 'transparent' }}>{params?.value}</Typography>}
              enterDelay={2000}
              sx={{
                backgroundColor: 'transparent',
                boxShadow: 'none',
                '.MuiTooltip-tooltip': {
                  backgroundColor: 'transparent',
                  boxShadow: 'none',
                  padding: 0,
                },
              }}
            >
              <Box
                sx={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  flexGrow: 1, // Takes up remaining space
                  color: isClone ? 'text.subtask' : '',
                  fontWeight: isClone ? 'bold' : '',
                }}
              >
                {value || ''}
              </Box>
            </Tooltip>

            {ncoStatus && <AddRoadIcon sx={{ color: 'rgba(159, 90, 253, 1)', height: 20, width: 20 }} />}
          </>
        ) : (
          <Typography
            sx={{
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              fontSize: densityStyles.fontSize,
              fontWeight: isParent ? 600 : 400,
              ml: isParent ? 1 : 0,
              color: row?.isProduct ? 'text.highlight' : 'text.primary',
            }}
          >
            {value}
          </Typography>
        )}
      </>
    </Box>
  )
}
export default RenderDealNameCell
